import en from './en';

export const LOCALES: string[] = ['en'];

export default { en: { translation: en } };
